import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import {
  rectificationsBySupplierDataSelector,
  rectificationsBySupplierFiltersSelector,
  reportIsVisibleSelector,
} from '../../../../../store/selectors/reportsSelectors';
import { setRectificationsBySupplierFilters } from '../../../../../store/slices/reportsSlice';
import { getRectificationsBySupplierReportThunk } from '../../../../../store/thunks/reports/reportsThunks';
import { BIG_TABLES_PAGE_SIZES } from '../../../../../core/utils/regex';
import Pagination from '../../../../../core/components/pagination/Pagination';
import RectificationsBySupplierTable from './table/RectificationsBySupplierTable';

const RectificationsBySupplierContent: React.FC = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(rectificationsBySupplierFiltersSelector);
  const tableData = useAppSelector(rectificationsBySupplierDataSelector);
  const reportIsVisible = useAppSelector(reportIsVisibleSelector);

  return (
    <>
      <div className="actions-and-paging">
        <Pagination
          currentPage={filters.page}
          pageSize={filters.pageSize}
          totalItems={tableData.totalCount}
          onChange={(page, pageSize) => {
            const newFilters = { ...filters, page, pageSize };
            dispatch(setRectificationsBySupplierFilters(newFilters));
            reportIsVisible && dispatch(getRectificationsBySupplierReportThunk({ filters: newFilters }));
          }}
          className="actions-and-paging__paging"
          pageSizeOptions={BIG_TABLES_PAGE_SIZES}
          narrow
        />
      </div>
      <RectificationsBySupplierTable />
    </>
  );
};

export default RectificationsBySupplierContent;
